import { decodeHtmlEntities, escapeJsonNewLine, sanitizeHtmlTags } from "./transformFunctions";
import { createTransformPipeline } from "./transformPipeline";

export const globalI18nTransformPipeline = createTransformPipeline<string>([escapeJsonNewLine]);

export const globalStringSanitizePipeline = createTransformPipeline<string>([sanitizeHtmlTags, decodeHtmlEntities]);
